const API_HOST = (process.env.VUE_APP_API_HOST || '').trim();

const normalizedApiHost = API_HOST.replace(/\/$/, '');

export const API_BASE_URL = normalizedApiHost
	? `${normalizedApiHost}/api`
	: '/api';
